import { gql } from '@optools/services/operator-gateway/types/generated';

export const PIPELINE_MONITORS = gql(`
  query pipelineMonitors {
    pipelineMonitors {
      pipelineConfig {
        fronthaulDecoderServiceLabel
        id,
        teamId
      }
      eventPipeline {
        status
      }
    }
  }
`);
